import FluctuatedPriceIcon from 'components-v2/atoms/FluctuatedPriceIcon';
import CartPriceAfterVoucherLabel from 'components-v3/organisms/PriceBreakdown/CartPriceAfterVoucherLabel';
import { formatCurrency } from 'utils/FormatNumber';
import { getCartItemPriceAfterVoucher } from 'utils/PriceBreakdownUtils';
import styles from './styles.module.css';

const CartItemPriceMobile = ({ product }) => {
  const {
    displayPrice = 0,
    salePrice = 0,
    // currentPrice là giá tại thời điểm thêm vào giỏ, không phải giá hiện tại
    currentPrice = 0,
    fluctuatedType,
    isDeal = false,
    deal = null,
  } = product || {};

  // BV-1586: dòng có voucher phân bổ vào SKU -> giá chính = priceAfterVoucher, gạch ngang price của
  // cart item (deal/campaign thì là giá deal), nhãn "ราคาหลังหักส่วนลด". Không có field thì như cũ.
  const cartPriceAfterVoucher = getCartItemPriceAfterVoucher(product);
  if (cartPriceAfterVoucher) {
    return (
      <div className={styles.price_after_voucher}>
        <div className={styles.price_row}>
          <FluctuatedPriceIcon fluctuatedType={fluctuatedType} />
          <span className={styles.current_price} data-test="price-after-voucher-mobile">
            {formatCurrency(cartPriceAfterVoucher.priceAfterVoucher)}
          </span>
          <span className={styles.old_price} data-test="old-price-text-mobile">
            {formatCurrency(cartPriceAfterVoucher.price)}
          </span>
        </div>
        <CartPriceAfterVoucherLabel className={styles.price_after_voucher_label} />
      </div>
    );
  }

  // Item biến động giá: gạch ngang currentPrice, giống bản desktop ở ProductCardBuy.
  // Chặn currentPrice = 0 để không render ra giá gạch ngang bằng 0 khi thiếu data.
  const isShowFluctuatedPrice = !!fluctuatedType && currentPrice > 0;
  // Item deal: giữ nguyên hành vi cũ, gạch ngang salePrice.
  const isShowDealPrice = isDeal && !!deal && salePrice > 0 && salePrice !== displayPrice;
  const oldPrice = (isShowFluctuatedPrice && currentPrice) || (isShowDealPrice && salePrice) || 0;

  return (
    <div className={styles.price_row}>
      <FluctuatedPriceIcon fluctuatedType={fluctuatedType} />
      <span className={styles.current_price}>{formatCurrency(displayPrice)}</span>
      {oldPrice > 0 && (
        <span className={styles.old_price} data-test="old-price-text-mobile">
          {formatCurrency(oldPrice)}
        </span>
      )}
    </div>
  );
};

export default CartItemPriceMobile;
